module.exports = __webpack_public_path__ + "img/qxqp.de3d30b5.svg";